import React, { useState } from "react";
import { 
  Box, 
  Typography, 
  Button, 
  TextField,
  useMediaQuery,
  useTheme 
} from "@mui/material";
import OneTimeUserTableDisplay from "../components/OneTimeUserTableDisplay";
import OneTimeUserFormDialog from "../components/OneTimeUserFormDialog";
import SuccessDialog from "../components/SuccessDialog";
import { useOneTimeUserTable } from "../hooks/useOneTimeUserTable";

const OneTimeUserTable = ({ oneTimeUsers, setOneTimeUsers, departments, setError, isEdit }) => {
  const [open, setOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [adderror, setAddError] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const {
    handleAddEmployeeSubmit,
    handleDeleteEmployee,
    handleUndoDelete,
    handleExcelUpload,
    handleDownloadTemplate,
    filteredUsers,
    totalPages,
    currentRows,
    handlePageChange,
    renderPageNumbers,
    handleEditClick,
    rowsPerPage,
  } = useOneTimeUserTable({
    oneTimeUsers,
    setOneTimeUsers,
    departments,
    setError,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    password,
    setPassword,
    showPassword,
    setShowPassword,
    selectedDepartment,
    setSelectedDepartment,
    departmentId,
    setDepartmentId,
    editIndex,
    setEditIndex,
    adderror,
    setAddError,
    searchTerm,
    setSearchTerm,
    page,
    setPage,
    setOpen,
    setSuccessOpen,
    rowsPerPage: 10
  });

  // Modified handleAddEmployeeSubmit to ensure editIndex is preserved
  const wrappedHandleAddEmployeeSubmit = (e) => {
    e.preventDefault();
    handleAddEmployeeSubmit(e);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        One Time Users
      </Typography>
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" },
        gap: 2, 
        mb: 2, 
        alignItems: { xs: "stretch", sm: "center" } 
      }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search by Name or Email or Department"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(1);
          }}
          sx={{
            width: { xs: "100%", sm: 350 },
            "& .MuiOutlinedInput-root": {
              height: "40px",
              fontSize: "0.875rem",
              background: "transparent",
              "& fieldset": { borderColor: "#666" },
              "&:hover fieldset": { borderColor: "#0191c8" },
              "&.Mui-focused fieldset": { borderColor: "#0191c8" },
            },
          }}
          className="form-control"
        />
        
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 1,
          justifyContent: { xs: "center", sm: "flex-start" }
        }}>
          {isEdit && (
            <img
              src="/images/Templaedownloadbg.png"
              alt="upload"
              style={{ 
                width: '75px', 
                height: '75px', 
                cursor: 'pointer',
                objectFit: 'contain'
              }}
              onClick={handleDownloadTemplate}
            />
          )}
          {isEdit && (
            <img
              src="/images/blukuploadbg.png"
              alt="upload"
              style={{ 
                width: '75px', 
                height: '75px', 
                cursor: 'pointer',
                objectFit: 'contain'
              }}
              onClick={() => document.getElementById("uploadFile").click()}
            />
          )}
          {isEdit && (
            <input
              id="uploadFile"
              type="file"
              accept=".xlsx, .xls"
              style={{ display: "none" }}
              onChange={handleExcelUpload}
            />
          )}
        </Box>

        <Button
          className="btn BlueBtn"
          variant="outlined"
          onClick={() => {
            setEditIndex(null);
            setFirstName("");
            setLastName("");
            setEmail("");
            setPassword("");
            setShowPassword(false);
            setSelectedDepartment("");
            setDepartmentId("");
            setAddError("");
            setOpen(true);
          }}
          sx={{
            textTransform: "none",
            color: "white !important",
            backgroundColor: "#0191c8",
            "&:hover": { backgroundColor: "#0191c8 !important", borderColor: "#0191c8 !important" },
            width: { xs: "100%", sm: "auto" },
            minWidth: { xs: "100%", sm: "200px" }
          }}
        >
          Add One Time User
        </Button>
      </Box>

      <OneTimeUserTableDisplay
        currentRows={currentRows}
        page={page}
        handleEditClick={handleEditClick}
        handleDeleteEmployee={handleDeleteEmployee}
        handleUndoDelete={handleUndoDelete}
        totalPages={totalPages}
        renderPageNumbers={renderPageNumbers}
        handlePageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
      />

      <OneTimeUserFormDialog
        open={open}
        setOpen={setOpen}
        departments={departments}
        handleAddEmployeeSubmit={wrappedHandleAddEmployeeSubmit}
        oneTimeUsers={oneTimeUsers}
        editIndex={editIndex}
        setEditIndex={setEditIndex}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        selectedDepartment={selectedDepartment}
        setSelectedDepartment={setSelectedDepartment}
        departmentId={departmentId}
        setDepartmentId={setDepartmentId}
        adderror={adderror}
        setAddError={setAddError}
      />

      <SuccessDialog
        successOpen={successOpen}
        setSuccessOpen={setSuccessOpen}
        editIndex={editIndex}
      />
    </Box>
  );
};

export default OneTimeUserTable;
